import React, { useEffect, useMemo, useState } from "react";
import { useGetProformaInvoiceSearchDTO } from "../../../Reports/ReportList/Hook";
import CustomerCombo from "../../../Reports/ReportList/ReListByOrders/Components/CustomerCombo";
import { Grid } from "@mui/material";
import DesignerCombo from "../../../Reports/ReportList/ReListByOrders/Components/DesignerCombo";
import ComboBox from "../../../Reports/ReportList/Components/ComboBox";
import YearsDrop from "../components/YearsDrop";
import Month from "../components/Month";
import PersianDatePicker from "../components/PersianDatePicker";

function Filter({
  setFieldValue,
  setDesignerFiled,
  customerFieldValue,
  designerFiled,
  year,
  setYear,
  chartFilter,
  month,
  setMonth,
  day,
  setDay
}) {
  const { data } = useGetProformaInvoiceSearchDTO();
  const [inputValue, setInputValue] = useState("");
  const [inpDesigner, setInpDesigner] = useState("");

  const optionCustomer = useMemo(() => {
    return data?.customers?.map((item) => ({
      label: item.key,
      value: item.value,
    }));
  }, [data?.customers]);
  const optionDesigner = useMemo(() => {
    return data?.designers?.map((item) => ({
      label: item.key,
      value: item.value,
    }));
  }, [data?.designers]);


  return (
    <Grid container sx={{ width: "100%", display: "flex" }}>
      <Grid item sx={{ flex: 1 }}>
         {(chartFilter.enum === 0) && (
              <PersianDatePicker year={year} setYear={setYear} month={month} setMonth={setMonth} day={day} setDay={setDay} withDay />
        )}
         {(chartFilter.enum === 1) && (
              <PersianDatePicker year={year} setYear={setYear} month={month} setMonth={setMonth} />
        )}
        {(chartFilter.enum === 2) && (
          <YearsDrop year={year} setYear={setYear} />
        )}
      </Grid>

      <Grid item sx={{ flex: 1 }}>
        <ComboBox
          lable={"نام طراح"}
          inputValue={inpDesigner}
          setInputValue={setInpDesigner}
          value={designerFiled}
          setValue={setDesignerFiled}
          options={optionDesigner}
        />
      </Grid>

      <Grid item sx={{ flex: 1 }}>
        <ComboBox
          lable={"نام مشتریان"}
          inputValue={inputValue}
          setInputValue={setInputValue}
          value={customerFieldValue}
          setValue={setFieldValue}
          options={optionCustomer}
        />
      </Grid>
    </Grid>
  );
}

export default Filter;
